import { APP_CONFIG } from "../base";

export {
    getAppDefaultMessage,
    setAppDictionary,
    getTextFromAppDictionary
}

const DICTIONARY: AppDictionaryStore = {
    appDictionary: null
}

/**
 * Get message from dictionary by provided chain.
 * Interface: AppDefaultMessages.
 *
 * @param path dot notation chain into prop e.g.: 'errors.default'
 */
const getAppDefaultMessage = (path: string): string | any => {
    try {
        return path.split('.').reduce((val, curr) => {
            if (val[curr]) {
                return val[curr];
            }
            throw {};
        }, APP_CONFIG.messages);
    }
    catch (e) {
        console.warn(`Error occured. Do path: '${path}' exists in AppDefaultMessages?`);
        return '';
    }
}

const setAppDictionary = (dictionary: AppDictionary) => {
    DICTIONARY.appDictionary = Object.assign({}, dictionary, { messages: APP_CONFIG.messages });
};

/**
 * Getter for text or object from interface AppDictionary.
 * Returns empty string if path is not found.
 * Should be used only in React application with config AppMainConfig.
 *
 * @param path - e.g.: 'products.buttons.product'
 */
const getTextFromAppDictionary = (path: string): string | any => {
    if (DICTIONARY.appDictionary) {
        try {
            return path.split('.').reduce((val, curr) => {
                if (val[curr]) {
                    return val[curr];
                }
                throw {};
            }, DICTIONARY.appDictionary);
        }
        catch (e) {
            console.warn(`Error occured. Do path: '${path}' exists?`);
            return '';
        }
    }
    return '';
};
